module.exports = __webpack_public_path__ + "../resources/img/ic_plus.8839e8d9.svg";